import { cn } from '@/lib/cn';

export type BrandMarkProps = {
  size?: number;
  animate?: boolean;
  className?: string;
};

/**
 * QuantPhi's orbital φ: one axis inside a tilted orbit. The orbit's front crosses over the axis
 * and its back passes behind; open cuts keep both legible on any background.
 */
export function BrandMark({ size = 20, animate = false, className }: BrandMarkProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={cn('shrink-0 text-brand', animate && 'animate-rung-in', className)}
    >
      <path d="M26 38.4l0-33.4 12 0 0 30.6-3.1 0.9-3.1 0.8ZM60.8 24.9l0.4 1 0 1.4-0.2 1.2-0.5 1.2-0.8 1.3-1.3 1.5-1.4 1.3-1.6 1.3-1.8 1.3-2 1.2-2.2 1.2-2.9 1.4-2.5 1-2.7 1-2.7 0.9-2.9 0.8-3.3 0.8-2.9 0.6-2.8 0.4-2.8 0.3-2.7 0.2-2.6 0.1-2.5 0-2.3-0.2-2.2-0.3-2-0.5-1.7-0.5-1.5-0.7-1.3-0.8-1-0.9-0.8-1.1-0.4-1-0.1-1.2 0.1-1 0.3-1 0.5-1 0.6-1.1 1.1-1.3 1.1-1.1 1.2-1.1 1.4-1 1.9-1.3 3.6-2 2.4-1.2 2.1-0.9 4.5-1.6 0 5.2-4.1 1.5-3.5 1.5-3 1.5-2.4 1.6-1.1 0.8-0.6 0.7-0.7 0.8-0.3 0.6-0.2 0.6 0 0.6 0.2 0.5 0.4 0.6 0.6 0.4 0.6 0.4 1.1 0.3 1 0.3 2.4 0.3 2.9 0 3.6-0.2 3.7-0.4 3.8-0.6 4.4-0.9 3.9-1 4.2-1.3 4-1.5 3.2-1.3 2.8-1.5 2.5-1.5 1.7-1.4 0.7-0.7 0.5-0.7 0.3-0.8 0.1-0.5-0.1-0.7-0.3-0.4-0.4-0.5-0.6-0.3-0.8-0.4-1-0.3-2.6-0.4-2.8-0.1-3.5 0.1-3.8 0.4 0-4.9 3.7-0.2 3.4 0 3.5 0.3 2.7 0.5 2.4 0.7 1 0.5 1.2 0.6 0.9 0.7 0.7 0.6 0.5 0.6ZM38 45.8l0 13.2-12 0 0-10.8 3-0.4 2.9-0.5 3-0.7Z" />
    </svg>
  );
}
